import { useContext } from 'react';
import { DimensionsContext } from '../context/DimensionsContext';
export const useDimensions = () => useContext(DimensionsContext);
//# sourceMappingURL=useDimensions.js.map